import React, { Component } from 'react';
import { Types, Game, Scene, GameObjects } from 'phaser';

import { ISceneConfig } from '../interfaces';
import { TextView } from './TextView';
import { TourPointContent } from './TourPointContent';
import { Mixpanel } from './Mixpanel';
import { SceneEvents } from '../scenes/SceneEvents';
import { SceneIds } from '../scenes/SceneIds';
import tourpoints from '../data/tourpoints_luxortemple_es.json';
import settings from '../data/settings_luxortemple_es.json';
import translations from '../data/translations.json';

interface Props {
  config: ISceneConfig,
  nodes: any,
  paths: any,
  overlay_nodes: any,
  gltf_nodes: any,
}

interface State {
  total: number;
  correct: number;
  current_location: number;
  time: number;
  currentPositionIndex: number;
}


const secondsToString = function(seconds: number) {
  const date = new Date(null);
  date.setSeconds(seconds);
  return date.toISOString().substr(14, 5);
};


export class MiniScene extends Scene {
  private config: ISceneConfig = null;
  private rabbit: GameObjects.Sprite = null;

  constructor() {
    super({ key: SceneIds.Game });
    // this.onCaptureComplete = this.onCaptureComplete.bind(this);
  }

  init(config: ISceneConfig): void {
    this.config = config;
    // this.config.eventBus.addListener(SceneEvents.CaptureComplete, this.onCaptureComplete);
  }

  preload(): void {
    this.load.setBaseURL();
    // this.load.spritesheet('rabbit', 'assets/capture_sprite.png', {
    //   frameWidth: 400,
    //   frameHeight: 400
    // });
  }

  create(): void {
    this.rabbit = this.add.sprite(this.game.canvas.clientWidth / 2, this.game.canvas.clientHeight / 2, 'rabbit');
    const scale = Math.max(this.game.canvas.clientWidth, this.game.canvas.clientHeight) / 400;
    this.rabbit.scale = scale * 1.55;
  }

//   onCaptureComplete() {
//     const frames = this.anims.generateFrameNumbers('rabbit', { start: 0, end: 13 });
//
//     // add the start frame to the end so it looks right
//     frames.push(frames[0]);
//     this.anims.create({
//       key: 'captured',
//       frames: frames,
//       repeat: 0,
//       showOnStart: true,
//       hideOnComplete: false,
//     });
//
//     this.rabbit.anims.play('captured');
//   }
}

export class GameView extends Component<Props, State> {
  private interval: number | null = null;
  private canvasRef: React.RefObject<HTMLCanvasElement>;
  private nodes: any = null;
  private paths: any = null;
  private gltf_nodes: any = null;

  constructor(props: Props) {
    super(props);

    this.canvasRef = React.createRef<HTMLCanvasElement>();

    this.state = {
      total: props.config.gameState.total.value,
      time: 0,
      currentPositionIndex: 0,
      correct: 0,
      current_location: 0,
    }
    this.onTotalChanged = this.onTotalChanged.bind(this);
    this.onTimeElapsed = this.onTimeElapsed.bind(this);
    this.onHintClicked = this.onHintClicked.bind(this);
    this.onScoreClicked = this.onScoreClicked.bind(this);
    this.onCaptureComplete = this.onCaptureComplete.bind(this);
    this.onPrevPositionClicked = this.onPrevPositionClicked.bind(this);
    this.onNextPositionClicked = this.onNextPositionClicked.bind(this);
    this._movePosition = this._movePosition.bind(this);
  }

  componentDidMount() {
    // this.props.config.gameState.captured.onChanged(this.onCapturedChanged);
    this.props.config.gameState.total.onChanged(this.onTotalChanged);
    // this.props.config.eventBus.addListener(SceneEvents.CaptureComplete, this.onCaptureComplete);

    this.interval = setInterval(this.onTimeElapsed, 1000) as unknown as number;

    const config: Types.Core.GameConfig = {
      type: Phaser.CANVAS,
      scene: [MiniScene],
      canvas: this.canvasRef.current,
      width: this.canvasRef.current.clientWidth,
      height: 0, // this.canvasRef.current.clientHeight,

      transparent: true,
    };

    const game = new Game(config);
    game.scene.start(SceneIds.Game, this.props.config);
  }

  onCaptureComplete() {

  }

  onTimeElapsed() {
    const nextTime = this.state.time + 1;

    this.setState({
      time: nextTime,
    })
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }

    this.props.config.gameState.total.removeOnChanged(this.onTotalChanged);
    // this.props.config.gameState.captured.removeOnChanged(this.onCapturedChanged);
  }

  onTotalChanged(total: number) {
    this.setState({ total: total });
  }

  // onCapturedChanged(captured: number) {
  //   this.setState({ captured: captured });
  // }

  onHintClicked() {
    this.props.config.analytics.track('sdk_portal_hint');
    // this.props.config.eventBus.emit(SceneEvents.DisplayHint);
  }

  onScoreClicked() {
    if (this.props.config.gameState.debug.value) {
      this.props.config.eventBus.emit(SceneEvents.EndGame);
    }
  }

  _movePosition(point) {
    const { sdk } = this.props.config;

    if (point.mode === "DOLLHOUSE") {
      sdk.Mode.moveTo(sdk.Mode.Mode.DOLLHOUSE, {
        rotation: point.rotation,
      });
    } else if (point.mode === "FLOORPLAN") {
      sdk.Mode.moveTo(sdk.Mode.Mode.FLOORPLAN, {
        rotation: {x: 0, y: 0},
        position: {x: 0, y: 0, z: 0},
        zoom: point.zoom,
      });
    } else {
      let transition = sdk.Sweep.Transition.FLY;

      if (typeof point.transition !== "undefined" && point.transition) {
        transition = sdk.Sweep.Transition[point.transition];
      }

      sdk.Sweep.moveTo(point.sweep, {
        rotation: point.rotation,
        transition,
      }).then((sweepId) => {
        console.log('- at sweep id', sweepId);
      });
    }

  }

  _toggleObjects(_newPositionIndex) {

    // toggle portals
    for (let i = 0; i < this.props.nodes.length; ++i) {
      if (_newPositionIndex >= tourpoints.payload.objects.length - 1) {
        this.props.nodes[i].obj3D.visible = true;
      } else {
        this.props.nodes[i].obj3D.visible = false;
      }
    }

    // toggle overlays
    for (let i = 0; i < this.props.overlay_nodes.length; i++) {
      // if (typeof this.props.overlay_nodes[i].components[0].inputsCache.showOnStep !== "undefined" || this.props.overlay_nodes[i].components[0].inputsCache.showOnStep !== null) {
      //   if (currentPositionIndex === this.props.overlay_nodes[i].components[0].inputsCache.showOnStep) {
      //     this.props.overlay_nodes[i].obj3D.visible = true;
      //   } else {
      //     this.props.overlay_nodes[i].obj3D.visible = false;
      //   }
      // }

      if (settings.slug === "menna") {
        if (_newPositionIndex === 18) {
          this.props.overlay_nodes[i].obj3D.visible = true;
        } else {
          this.props.overlay_nodes[i].obj3D.visible = false;
        }
      }
    }

    // toggle 3d objects
    if (this.props.gltf_nodes && this.props.gltf_nodes.length) {
      // for (let i = 0; i < this.props.gltf_nodes.length; ++i) {
      //   if (_newPositionIndex >= 0 && _newPositionIndex < tourpoints.payload.objects.length) {
      //     this.props.gltf_nodes[i].obj3D.visible = true;
      //   } else {
      //     this.props.gltf_nodes[i].obj3D.visible = false;
      //   }
      // }
      if (settings.slug === "khufu") {
        for (let i = 0; i < this.props.gltf_nodes.length; ++i) {
          if (_newPositionIndex >= 2 && _newPositionIndex <= 5) {
            this.props.gltf_nodes[i].obj3D.visible = true;
          } else {
            this.props.gltf_nodes[i].obj3D.visible = false;
          }
        }
      }
      if (settings.slug === "sardis_artemis") {
        if (_newPositionIndex >= 0 && _newPositionIndex < 1) {
          this.props.gltf_nodes[0].obj3D.visible = true;
        } else {
          this.props.gltf_nodes[0].obj3D.visible = false;
        }
        if (_newPositionIndex >= 1 && _newPositionIndex < 2) {
          this.props.gltf_nodes[1].obj3D.visible = true;
        } else {
          this.props.gltf_nodes[1].obj3D.visible = false;
        }
        if (_newPositionIndex >= 2 && _newPositionIndex < 3) {
          this.props.gltf_nodes[2].obj3D.visible = true;
        } else {
          this.props.gltf_nodes[2].obj3D.visible = false;
        }
        if (_newPositionIndex >= 3 && _newPositionIndex < 4) {
          this.props.gltf_nodes[3].obj3D.visible = true;
        } else {
          this.props.gltf_nodes[3].obj3D.visible = false;
        }
        if (_newPositionIndex >= 4 && _newPositionIndex < 5) {
          this.props.gltf_nodes[4].obj3D.visible = true;
        } else {
          this.props.gltf_nodes[4].obj3D.visible = false;
        }
      }
      if (settings.slug === "sardis_synagogue") {
        if (_newPositionIndex >= 0 && _newPositionIndex < 1) {
          this.props.gltf_nodes[0].obj3D.visible = true;
        } else {
          // this.props.gltf_nodes[0].obj3D.visible = false;
        }
      }
    }
  }

  onNextPositionClicked() {
    const { currentPositionIndex } = this.state;
    let _newPositionIndex = currentPositionIndex + 1;
    if (_newPositionIndex >= tourpoints.payload.objects.length) {
      _newPositionIndex = tourpoints.payload.objects.length - 1;
    }
    console.log("stepIndex", _newPositionIndex);

    this._movePosition(tourpoints.payload.objects[_newPositionIndex]);
    this._toggleObjects(_newPositionIndex);

    Mixpanel.track('User clicked next in Guided tour', {
      "current_step_index": _newPositionIndex,
    });

    this.setState({ currentPositionIndex: _newPositionIndex });
  }

  onFinalPositionClicked() {
    Mixpanel.track('User clicked final button in Guided tour', {
      "next_tour": settings.next_button_link
    });

    window.top.location.href = settings.next_button_link;
  }

  onPrevPositionClicked() {
    const { currentPositionIndex } = this.state;
    let _newPositionIndex = currentPositionIndex - 1;
    if (_newPositionIndex <= 0) {
      _newPositionIndex = 0;
    }
    console.log("stepIndex", _newPositionIndex);

    this._movePosition(tourpoints.payload.objects[_newPositionIndex]);
    this._toggleObjects(_newPositionIndex);

    Mixpanel.track('User clicked previous in Guided tour', {
      "current_step_index": _newPositionIndex,
    });

    this.setState({ currentPositionIndex: _newPositionIndex });
  }

  renderTourPoints() {
    const { currentPositionIndex } = this.state;

    return tourpoints.payload.objects.map((tourpoint, i) => {
      let isActive = i === currentPositionIndex
      return (
        <span key={i} className={`p-1 text-xs cursor-pointer hover:text-theme-200 ${isActive ? 'underline' : ''}`}>
          {tourpoint.name}
        </span>
      )
    });
  }

  render() {
    const { correct, total, current_location, currentPositionIndex } = this.state;

    return (
      <div className="z-50">
        <div id="game-overlay">
          <canvas
            height="0"
            className='basket no-pointer-events hidden'
            ref={this.canvasRef}
          />
        </div>

        <div className="fixed right-0 top-auto bottom-auto bg-theme-800 text-white z-50 p-2 hidden">
          <h2 className="font-sans-bold text-sm p-1">Itinerary</h2>
          <div className="flex flex-col items-start justify-start">
            {this.renderTourPoints()}
          </div>
        </div>

        {(currentPositionIndex >= 0 && tourpoints) ? (
          <TourPointContent point={tourpoints.payload.objects[currentPositionIndex]} />
        ): ''}

        <div className="prev-next-buttons fixed w-11/12 sm:w-6/12 max-w-xl left-0 right-0 bottom-4 sm:bottom-4 mx-auto z-50 flex flex-wrap sm:flex-nowrap overflow-hidden items-center justify-start pointer-events-none" style={{ opacity: "1" }}>

          <button className="cursor-pointer flex items-center justify-center py-2 pl-3 pr-4 rounded-lg text-xs md:text-md uppercase font-sans-bold text-white mr-4 pointer-events-auto text-shadow" onClick={this.onPrevPositionClicked.bind(this)}>
            <svg style={{width: "24px", height: "24px"}} viewBox="0 0 24 24" className="mr-2">
              <path fill="currentColor" d="M21,11H6.83L10.41,7.41L9,6L3,12L9,18L10.41,16.58L6.83,13H21V11Z" />
            </svg>
            {translations[settings.language]['Previous']}
          </button>
          {(currentPositionIndex >= tourpoints.payload.objects.length - 1) ? (
            <button className="cursor-pointer flex items-center justify-center bg-white hover:bg-theme-100 py-4 px-16 w-full sm:w-11/12 sm:mr-16 max-w-2xl rounded-lg shadow-xl text-base md:text-md uppercase font-sans-bold text-theme-900 pointer-events-auto" onClick={this.onFinalPositionClicked.bind(this)}>
              {settings.next_button_text}
            </button>
          ) : (
            <button className="cursor-pointer flex items-center justify-center bg-theme-700 hover:bg-theme-800 py-4 px-16 w-full sm:w-11/12 sm:mr-16 max-w-2xl rounded-lg shadow-xl text-base md:text-md uppercase font-sans-bold text-white pointer-events-auto" onClick={this.onNextPositionClicked.bind(this)}>
              {translations[settings.language]['Next']}
            </button>
          )}
        </div>

      </div>
    );
  }
}
